import React, { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useBooking } from "../context/BookingContext";

const FloatingCTA = () => {
  const { t } = useLang();
  const { setOpen } = useBooking();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Mobile sticky bottom bar */}
      <div
        className={`md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-gradient-to-t from-black to-transparent transition-all duration-300 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
        }`}
        data-testid="mobile-sticky-cta"
      >
        <button
          onClick={() => setOpen(true)}
          data-testid="mobile-book-btn"
          className="w-full bg-gold text-black font-display uppercase tracking-tight text-base py-4 rounded-sm cta-pulse flex items-center justify-center gap-2"
        >
          <Calendar className="h-4 w-4" strokeWidth={2.4} />
          {t.nav.book}
        </button>
      </div>

      {/* Desktop floating */}
      <button
        onClick={() => setOpen(true)}
        data-testid="desktop-floating-book"
        className={`hidden md:flex fixed bottom-8 right-8 z-40 items-center gap-2 bg-gold text-black px-6 py-4 rounded-full font-display uppercase tracking-tight text-sm cta-pulse transition-all duration-500 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0 pointer-events-none"
        } hover:scale-105`}
      >
        <Calendar className="h-4 w-4" strokeWidth={2.4} />
        {t.nav.book}
      </button>
    </>
  );
};

export default FloatingCTA;
